import React from 'react';
import classnames from 'classnames';
import s from './TextTooltipContent.scss';
var SHORT_CONTENT_THRESHOLD = 30;
/** @deprecated */
var TextTooltipContent = function (_a) {
    var textClassName = _a.textClassName, title = _a.title, tooltipText = _a.tooltipText;
    var isShortContent = typeof tooltipText === 'string' &&
        tooltipText.length <= SHORT_CONTENT_THRESHOLD;
    var alignment = (isShortContent && 'center') || undefined;
    return (React.createElement("div", { className: s['wrapper'] },
        title && React.createElement("div", { className: s['title'] }, title),
        React.createElement("div", { className: classnames(s['text'], alignment && s["align-".concat(alignment)], textClassName) }, tooltipText)));
};
export default TextTooltipContent;
//# sourceMappingURL=TextTooltipContent.js.map